import { FLOW } from "../../../../reducers/website/types"
import BookingsList from "../Bookings/BookingsList"

export default function FleetAllocations(){
  return (
    <BookingsList flow={FLOW.FLEET_ALLOCATION}/>
  )
}